import { useMemo } from 'react';
import api from '../services/api';

/**
 * Hook para manejar el contexto de sesión (remota o presencial)
 * Detecta si el juego está siendo jugado dentro de una sesión
 */
export function useSessionContext() {
  const searchParams = new URLSearchParams(window.location.search);
  const sesionRemota = searchParams.get('sesion_remota');
  const sesionJuego = searchParams.get('sesion_juego');
  const sesionPresencial = searchParams.get('sesion');

  const sessionContext = useMemo(() => {
    const isInSession = !!(sesionRemota && sesionJuego) || !!(sesionPresencial && sesionJuego);
    const sessionType = sesionPresencial ? 'presencial' : sesionRemota ? 'remota' : null;

    return {
      isInSession,
      sessionType,
      sesionJuego,
      sesionRemota,
      sesionPresencial,
    };
  }, [sesionRemota, sesionJuego, sesionPresencial]);

  /**
   * Guardar resultado en la sesión
   */
  const saveSessionResult = async (data: {
    tiempo: number;
    movimientos: number;
    completado: boolean;
    datos_juego?: any;
  }) => {
    if (!sessionContext.sesionJuego) {
      return;
    }

    try {
      await api.post(`/sessions/games/${sessionContext.sesionJuego}/result`, {
        tiempo: data.tiempo,
        movimientos: data.movimientos,
        completado: data.completado,
        datos_juego: data.datos_juego || {},
      });
    } catch (error) {
      console.error('Error al guardar resultado en sesión:', error);
      // No bloqueamos el flujo si falla el guardado en sesión
    }
  };

  return {
    ...sessionContext,
    saveSessionResult,
  };
}
